<template>
	<div class="swiper page-container">
		<custom-table :pageConfig="pageConfig" :multipleSelection="multipleSelection" :buttonGroup="buttonGroup"
			:filterValue="filterValue" :tableFilter="tableFilter" :tableConfig="tableConfig" :tableData="tableData"
			@pageChange="pageChange" @buttonClick="buttonClick" @filterChange="filterChange"
			@scopeButtonClick="scopeButtonClick">
		</custom-table>
		<el-dialog title="轮播图编辑" :visible.sync="dialogFormVisible" width="500px" custom-class="generalDialog" @close="accountDialogClose()">
			<el-form ref="swiperForm" :model="swiperForm" :label-width="swiperFormLabelWidth" :rules="swiperFormRules">
				<div class="upload-banner">
					<div class="upload-banner-label"><span>*</span>上传图片</div>
					<el-upload class="banner-uploader" :action="bannerUploadUrl" :show-file-list="false"
						:on-success="handleBannerSuccess" :before-upload="beforeBannerUpload"
						:on-progress="onBannerUpload" :headers="{'Authtoken':token}" accept="image/*">
						<img v-if="swiperForm.imageUrl" :src="$pub.imageUrl+swiperForm.imageUrl" class="banner">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</div>
				<el-form-item label="链接" prop="link">
					<el-input v-model="swiperForm.link" autocomplete="off" placeholder="请输入轮播图跳转链接" clearable>
					</el-input>
				</el-form-item>
				<el-form-item label="状态" prop="status">
					<el-select v-model="swiperForm.status" placeholder="请选择状态" clearable>
						<el-option v-for="(item,index) in statusList" :key="index" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="accountDialogClose">取 消</el-button>
				<el-button type="primary" :loading="loading" @click="accountDialogConfirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'swiper',
		data() {
			return {
				// 表单相关
				dialogFormVisible: false,
				bannerUploadUrl: '',
				swiperFormLabelWidth: '80px',
				swiperForm: {
					imageUrl: '',
					link: '',
					status: ''
				},
				statusList: [{
						label: '启用',
						value: 1
					},
					{
						label: '禁用',
						value: 0
					}
				],
				swiperFormRules: {
					status: [{
						required: true,
						trigger: 'blur',
						message: '请选择状态'
					}]
				},
				loading: false,
				// 表格相关
				pageConfig: {
					totalWord: '全部数据',
					total: 0,
					pageSize: 5,
					currentPage: 1,
				},
				multipleSelection: [],
				buttonGroup: [{
					type: 'primary',
					size: 'mini',
					plain: true,
					icon: 'el-icon-plus',
					word: '添加轮播图',
					sign: 'new'
				}],
				filterValue: {},
				tableFilter: [],
				tableConfig: {
					border: true,
					selection: false,
					showOverflowTooltip: true,
					tableHeader: [{
							prop: 'status',
							label: '状态',
							width: 100,
							template: true
						},
						{
							prop: 'address',
							label: '缩略图',
							width: 400,
							template: true
						},
						{
							prop: 'url',
							label: '链接',
							width: 300
						}
					],
					tableEvent: [{
							icon: 'el-icon-edit',
							name: '编辑',
							color: 'blue',
							sign: 'edit'
						},
						{
							icon: 'el-icon-delete',
							name: '删除',
							color: 'red',
							sign: 'delete'
						}
					],
					emptyDescription: '当前没有数据',
				},
				tableData: [],
				token: '',
				operationId: ''
			};
		},
		methods: {
			pageChange() {
				this.fetchData()
			},
			buttonClick(sign) {
				if (sign === 'new') {
					this.dialogFormVisible = true
				}
			},
			filterChange() {
				console.log(this.filterValue);
			},
			scopeButtonClick(row, sign) {
				this.operationId = row.id
				if (sign === 'edit') {
					this.swiperForm = {
						imageUrl:row.address,
						link:row.url,
						status:row.status
					}
					this.dialogFormVisible = true
				}
				if (sign === 'delete') {
					this.$confirm('确认要删除这个轮播图吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$api.swiperDelete({
							id: this.operationId
						}, res => {
							if (res.code == 200) {
								this.fetchData()
								this.$message({
									message: '删除成功',
									type: 'success',
									duration: 2000
								})
							}
						})
					}).catch(() => {});
				}
			},
			// 上传头像成功
			handleBannerSuccess(res) {
				if (res.code == 200) {
					this.swiperForm.imageUrl = res.data.fileUrl
				}
			},
			onBannerUpload() {

			},
			beforeBannerUpload(file) {
				const isLt10M = file.size / 1024 / 1024 < 10;
				if (!isLt10M) {
					this.$message.error('上传图片大小不能超过 10MB!');
				}
				return isLt10M;
			},
			accountDialogClose() {
				this.operationId = ''
				this.swiperForm = {
					imageUrl: '',
					link: '',
					status: ''
				}
				// this.$refs['swiperForm'].resetFields()
				this.dialogFormVisible = false
			},
			accountDialogConfirm() {
				if (this.swiperForm.imageUrl == '') {
					this.$message({
						type: 'error',
						message: '请上传图片'
					})
				}
				this.$refs.swiperForm.validate(valid => {
					if (valid) {
						this.loading = true
						this.$api.swiperEdit({
							address: this.swiperForm.imageUrl,
							url: this.swiperForm.link,
							status: this.swiperForm.status,
							id: this.operationId
						}, res => {
							if (res.code == 200) {
								this.loading = false
								this.fetchData()
								this.accountDialogClose()
								this.$message({
									message: (this.operationId == '' ? '添加' : '编辑')+ '轮播图成功！',
									duration: 2000,
									type: 'success',
									onClose: () => {

									}
								})
							}
						})
					}
				})
			},
			fetchData() {
				this.$api.swiperList({
					pageSize: this.pageConfig.pageSize,
					pageNum: this.pageConfig.currentPage
				}, res => {
					if (res.code == 200) {
						this.tableData = res.data.list
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.bannerUploadUrl = this.$pub.requestUrl + '/uploadImg'
			this.token = this.$pub.getStorage('adm_token')
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.upload-banner {
		width: 100%;
		display: flex;
		margin-bottom: @vue-spacing-col-lg;

		.upload-banner-label {
			width: 80px;
			display: flex;
			justify-content: flex-end;
			padding-right: 10px;
			box-sizing: border-box;

			span {
				color: @vue-text-color-red;
			}
		}
	}

	.avatar-uploader .el-upload {
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.banner-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		border: 1px dashed #d9d9d9;
		font-size: 28px;
		color: #8c939d;
		width: 376px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.banner {
		width: 376px;
		height: 178px;
		display: block;
	}
</style>
